// The access token lives in a module variable, never in web storage: anything
// localStorage holds is readable by any injected script, so a single XSS flaw
// would exfiltrate it. Being memory-only, it dies with the page — the httpOnly
// refresh cookie is what revives the session (see refreshAccessToken).
let accessToken = null;

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
  accessToken = token || null;
};
